module.exports = __webpack_public_path__ + "img/sunny_night.6fce0eaf.svg";